import * as React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";

export const NewsletterDisclaimer = ({ settings }) => {
    const alignmentClass = `text-${settings.content_alignment}`;
    
    // Create the disclaimer text with links
    const privacyPolicyUrl = settings.privacy_policy_url || '/pages/privacy-policy';
    const termsUrl = settings.terms_url || '/pages/terms-of-service';
    
    // Parse the disclaimer text from richtext if needed
    const rawText = settings.disclaimer_text || '*By subscribing you agree to with our privacy policy and terms and conditions';
    const disclaimerText = rawText.replace(/<[^>]*>/g, '');
    
    // Replace placeholders with actual links if they exist in the text
    let formattedText = disclaimerText;
    if (disclaimerText.includes('privacy policy')) {
        formattedText = formattedText.replace('privacy policy', `<a href="${privacyPolicyUrl}" class="underline hover:opacity-80">privacy policy</a>`);
    }
    if (formattedText.includes('terms and conditions')) {
        formattedText = formattedText.replace('terms and conditions', `<a href="${termsUrl}" class="underline hover:opacity-80">terms and conditions</a>`);
    }
    
    return (
        <div className={`newsletter-signup__disclaimer mt-4 ${alignmentClass}`}>
            <Paragraph 
                text={formattedText}
                type="b5"
                dangerouslySetInnerHTML={true}
            />
        </div>
    );
};

export default NewsletterDisclaimer;